import React from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Typography,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  Box
} from "@mui/material";
import { Link } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import * as authenticationApi from "../../api/authenticationApi";
import { connect } from "react-redux";
import * as authenticationActions from "../../store/actions/authenticationActions";
import { bindActionCreators } from "redux";
import { withRouter } from "../common/WithRouter";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        twoFactorCodeFromClient: "",
        username: "",
        password: "",
      },
      message: "",
      redirect: false,
      errors: {},
      open: true,
    };
  }

  onChange = (e) => {
    let errors = { ...this.state.errors };
    errors[e.target.name] = "";
    this.setState({ errors });
    const user = { ...this.state.user };
    user[e.target.name] = e.target.value;
    this.setState({ user });
  };

  onSubmit = async (e) => {
    e.preventDefault();
    if (!this.formIsValid()) return;

    const { user } = this.state;

    const signedInUser = await authenticationApi.login(user);
    if (signedInUser === undefined) {
      this.setState({ message: "Brukernavn eller passordet er feil" });
    } else {
      sessionStorage.setItem("token", JSON.stringify(signedInUser));

      const catalogsdata = require("../common/data.json");
      let roles = [];
      signedInUser.userRoles.forEach((arrayItem) => {
        roles.push(arrayItem.roleName);
      });

      const items = catalogsdata.catalogs.filter((c) =>
        c.permissions.some((p) => roles.includes(p))
      );

      const menuItems = items.filter((item) => item != null);

      const menu = menuItems.map(({ permissions, ...keepAttrs }) => keepAttrs);
      sessionStorage.setItem("menuitems", JSON.stringify(menu));
      const object = { signedInUser, menu };

      this.props.actions.userSignedInSuccess(object);

      // Redirect to original page or default
      const redirectUrl = this.props.location?.state?.from || "/";
      this.props.navigate(redirectUrl);
    }
  };

  formIsValid = () => {
    const { username, password } = this.state.user;
    const errors = {};

    if (!username) errors.username = "username er påkrevd";
    if (!password) errors.password = "password er påkrevd";

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleClose = () => {
    this.setState({ open: false });
    return this.props.navigate("/");
  };

  render() {
    if (this.props.signedin && sessionStorage.token) {
      return (
        <React.Fragment>
          <Dialog open={this.state.open} onClose={this.handleClose}>
            <DialogTitle>
              {
                "Du er nå innlogget i et system som behandler konfidensiell informasjon"
              }
            </DialogTitle>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary" autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      );
    }

    return (
      <Container component="main" maxWidth="xs" sx={{ pt: 12 }}>
        <CssBaseline />
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar sx={{ bgcolor: "primary.main", mb: 2 }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Logg inn
          </Typography>
          <Box component="form" onSubmit={this.onSubmit} sx={{ mt: 2, width: "100%" }}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              id="username"
              label="E-post eller Brukernavn"
              autoFocus
              name="username"
              value={this.state.user.username}
              onChange={this.onChange}
              required
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Passord"
              type="password"
              id="password"
              name="password"
              value={this.state.user.password}
              onChange={this.onChange}
              required
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Google Authenticator-koden (6-siffer)"
              id="twoFactorCodeFromClient"
              name="twoFactorCodeFromClient"
              value={this.state.user.twoFactorCodeFromClient}
              onChange={this.onChange}
            />
            <Typography color="error">{this.state.message}</Typography>
            <Box sx={{ pt: 2 }}>
              <Button type="submit" fullWidth variant="contained" color="primary">
                Logg inn
              </Button>
            </Box>
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs>
                <Link to="/forgotpassword">Glemt passord?</Link>
              </Grid>
              <Grid item>
                <Link to="/message">Har du ikke en brukerkonto?</Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  const signedin = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : "";
  return {
    signedin: signedin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      userSignedInSuccess: bindActionCreators(
        authenticationActions.userSignedInSuccess,
        dispatch
      ),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignIn));
